import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import SeoHead, {
  DEFAULT_DESCRIPTION,
  DEFAULT_TITLE,
  absoluteUrl,
} from '../../utils/seo';
import routes from '../../routes';
import {
  buildBulkSubscriptionSeo,
  getLandingCodeFromLocation,
} from '../../utils/bulkSubscriptionLanding';

const INDEXABLE_ROUTE_SEO = [
  {
    path: routes.halloweenLandingPage,
    exact: true,
    title: 'Halloween on SpotlightNews — All Treats. No Paywalls.',
    description: 'All treats, no paywalls. Explore SpotlightNews contests this Halloween, review the rules and find out how to enter.',
  },
  {
    path: routes.news.topArticles,
    exact: true,
    title: 'Top Articles',
    description: [
      'Read the most popular articles on Spotlight and discover what readers are',
      'following now.',
    ].join(' '),
  },
  {
    path: routes.discover,
    exact: true,
    title: 'Discover News, Publishers, Writers and Topics',
    description: [
      'Explore trusted publishers, writers, topics and articles curated inside',
      'Spotlight.',
    ].join(' '),
  },
  {
    path: routes.allPublishers,
    exact: true,
    title: 'All Publishers',
    description: [
      'Browse publishers available on Spotlight and follow the sources that matter',
      'to you.',
    ].join(' '),
  },
  {
    path: routes.contests,
    exact: true,
    title: 'Contests',
    description: 'Join Spotlight contests, challenges and reader experiences.',
  },
  {
    path: routes.bracketLp,
    exact: true,
    title: 'Bracket Challenge',
    description: 'Join the Spotlight Bracket Challenge and make your picks before the games begin.',
  },
  {
    path: routes.worldCupLp,
    exact: true,
    title: 'World Cup Challenge',
    description: 'Follow the Spotlight World Cup experience and participate in the challenge.',
  },
];

const findStaticSeo = (pathname) => INDEXABLE_ROUTE_SEO.find((route) => matchPath(pathname, {
  path: route.path,
  exact: route.exact,
}));

const isBulkSubscriptionLpPath = (pathname) => (
  pathname !== routes.halloweenLandingPage && (
    matchPath(pathname, { path: routes.bulkSubscriptionLp, exact: true })
    || matchPath(pathname, { path: routes.bulkSubscriptionLpClean(':landingCode'), exact: true })
  )
);

const RouteSeo = () => {
  const location = useLocation();
  const staticSeo = findStaticSeo(location.pathname);

  if (isBulkSubscriptionLpPath(location.pathname)) {
    const landingCode = getLandingCodeFromLocation(location);
    const seo = buildBulkSubscriptionSeo(null, landingCode);

    return (
      <SeoHead
        canonicalUrl={absoluteUrl(seo.canonicalPath)}
        description={seo.description}
        keywords={seo.keywords}
        ogDescription={seo.ogDescription}
        ogTitle={seo.ogTitle}
        title={seo.title}
      />
    );
  }

  if (staticSeo) {
    return (
      <SeoHead
        title={staticSeo.title}
        description={staticSeo.description}
        canonicalUrl={absoluteUrl(location.pathname)}
      />
    );
  }

  return (
    <SeoHead
      title={DEFAULT_TITLE}
      description={DEFAULT_DESCRIPTION}
      canonicalUrl={absoluteUrl(location.pathname)}
    />
  );
};

export default RouteSeo;
